import { Prices } from '@mitsubishi/shared/data-access';

export enum UnitAccessoryDisplayType {
  visible = 'visible',
  hidden = 'hidden',
  reserved = 'reserved',
}

export interface UnitAccessoryResponse {
  questions: UnitAccessoryQuestion[];
  totalAccessoryPrices: Prices;
  totalUnitPrices: Prices;
}

export interface UnitAccessoryQuestion {
  isQuestionVisible: boolean;
  questionCode: string;
  questionDescriptionId: number;
  questionType: 'single_choice' | 'multiple_choice';
  accessories: UnitAccessoryAnswer[];
  simulatableAccessories?: UnitAccessoryAnswer[];
  isSimulable: boolean;
  questionDescriptionTranslation?: string;
}

export interface BaseUnitAccessory {
  answerCode: string;
  questionCode: string;
}

export interface UnitAccessoryAnswer extends BaseUnitAccessory {
  answerDescription: string;
  answerDescriptionId: number;
  answerParentCode: string | null;
  answerTranslation: string | undefined;
  priceListCodFam: string;
  priceTypology: any;
  order: number;
  display: string;
  status: string;
  rowType?: string;
  performanceImpact: boolean;
  questionPerformanceImpact: boolean;
  priceListId: number;
  modelArticleCode: string;
  questionDescription: string;
  constraintVisible: any;
  sellInPrice: number | null;
  localPrice: number | null;
  priceList: number | null;
  enabled: boolean;
  constraintDescription: string | null;
  constraintModified: boolean;
  questionVisible: boolean;
  answerInfoResourceId: number;
  option: boolean;
  enabledDefault: boolean;
  responseQuestionIsCecommended: boolean;
  responseIsRecommended: boolean;
  version: boolean;
  recommended: boolean;
  finalProduct: boolean;
  type: any;
  trash: boolean;
  isTest: boolean;
  constraintAction: ConstraintAction | null;
  name: string | null;
  currencyId?: number;
}

export interface UnitAccessoriesConfigurationBasePayload {
  projectId: string;
  unitId: string;
  unitType: string;
  studyPerformanceId?: string;
}

export interface UnitAccessoryUpdatePayload extends UnitAccessoriesConfigurationBasePayload {
  questionId: string;
  answerId: string;
}

export enum ConstraintActionEnum {
  SS = 'SS',
  SE = 'SE',
  DS = 'DS',
  EE = 'EE',
  OS = 'OS',
  OE = 'OE',
  WW = 'WW',
}

interface ConstraintAction {
  action: ConstraintActionEnum;
  details: {
    type: string;
    questionCode: string;
    answerCode: string;
    questionDescriptionId: number;
    answerDescriptionId: number;
  }[];
}
